module.exports = __webpack_public_path__ + "files/31f15875975aab69085470aabbfec802.png";


//////////////////
// WEBPACK FOOTER
// ./images/next.png
// module id = 1162
// module chunks = 76